module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page.1a8a593c.jpg";